<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 17a4.5 4.5 0 114.5-4.5A4.51 4.51 0 0112 17zm0-7a2.5 2.5 0 102.5 2.5A2.5 2.5 0 0012 10z"/><path d="M15.17 6l1.12 1.12a3 3 0 002.12.88H20v10H4V8h1.59a3 3 0 002.12-.88L8.83 6h6.34m.42-2H8.41a1 1 0 00-.7.29L6.29 5.71a1 1 0 01-.7.29H3a1 1 0 00-1 1v12a1 1 0 001 1h18a1 1 0 001-1V7a1 1 0 00-1-1h-2.59a1 1 0 01-.7-.29l-1.42-1.42a1 1 0 00-.7-.29z"/><path d="M6 11a1 1 0 110-2 1 1 0 010 2z"/></svg>